'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$SelectedSite(site, selected) {
  this.kf = null;
  this.u1 = false;
  this.kf = site;
  this.u1 = selected;
}
export { $c_Lpresto_types$SelectedSite as $c_Lpresto_types$SelectedSite };
$p = $c_Lpresto_types$SelectedSite.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$SelectedSite;
/** @constructor */
function $h_Lpresto_types$SelectedSite() {
}
export { $h_Lpresto_types$SelectedSite as $h_Lpresto_types$SelectedSite };
$h_Lpresto_types$SelectedSite.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__hashCode__I("SelectedSite"));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().B(this.kf));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, (this.u1 ? 1231 : 1237));
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().al(acc, 2);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_types$SelectedSite)) {
    if ((this.u1 === x$0.u1)) {
      var x = this.kf;
      var x$2 = x$0.kf;
      return ((x === null) ? (x$2 === null) : x.i(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 2;
});
$p.s = (function() {
  return "SelectedSite";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.kf;
  }
  if ((n === 1)) {
    return this.u1;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.jk = (function() {
  return this.kf.e0;
});
$p.csr = (function() {
  return this.kf;
});
function $isArrayOf_Lpresto_types$SelectedSite(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.k8)));
}
export { $isArrayOf_Lpresto_types$SelectedSite as $isArrayOf_Lpresto_types$SelectedSite };
var $d_Lpresto_types$SelectedSite = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$SelectedSite, "presto.types$SelectedSite", ({
  k8: 1,
  aA: 1,
  k6: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$SelectedSite as $d_Lpresto_types$SelectedSite };
//# sourceMappingURL=presto.types$-Selected-Site.js.map
